import * as Sentry from '@sentry/react';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { CustomerPortalApiError } from '../customerPortalApi/customerPortalApiError';

// A CustomerPortalApiError anywhere along the cause chain was already
// captured by customerPortalApi, so wrapping one must not re-report it
export const holdsCustomerPortalApiError = (error: unknown): boolean => {
  let current: unknown = error;

  while (current instanceof Error) {
    if (current instanceof CustomerPortalApiError) {
      return true;
    }

    current = current.cause;
  }

  return false;
};

const captureUncapturedError = (error: unknown) => {
  if (!holdsCustomerPortalApiError(error)) {
    Sentry.captureException(error);
  }
};

export const createQueryClient = () =>
  new QueryClient({
    queryCache: new QueryCache({
      onError: captureUncapturedError,
    }),
    mutationCache: new MutationCache({
      onError: captureUncapturedError,
    }),
    defaultOptions: {
      queries: {
        // Must be a function, not omitted: in react-query 5.101 a failed refetch
        // only reaches the observer's error state when throwOnError is set.
        throwOnError: () => false,
      },
    },
  });
